// extracted by mini-css-extract-plugin
module.exports = {"DeliverySlotChecker":"DeliverySlotsChecker_DeliverySlotChecker__KKYwf","DeliverySlotChecker__title":"DeliverySlotsChecker_DeliverySlotChecker__title__1x4_g"};